<template>
  <div>
    <v-card
      class="customBorderRadius rounded my-2 fill-height"
      style="position: relative;"
    >
      <v-card-title class="white--text my-1 py-1 pt-4">
        <h3 style="color:#30475A;">
          Purchase Plan
        </h3>
      </v-card-title>
      <v-card-text class="ma-1 pa-2">
        <span
          v-if="discount > 0"
          class="ribbon ribbon-top-right"
          style="margin-top: -69px;padding-right: 0px!important;"
        >
          <span>{{ discount }}% Off</span>
        </span>

        <!-- Choose Plan -->
        <div class="section-label">Choose Plan</div>
        <div class="plan-card-grid" style="margin-top: 16px;">
          <v-card
            v-for="opt in planOptions"
            :key="opt.key"
            class="plan-card customBorderRadius"
            :class="{ selected: selectedPlanType === opt.key }"
            elevation="2"
            @click="selectPlan(opt.key)"
          >
            <v-card-text class="plan-card-content">
              <div class="plan-card-header">
                <div class="plan-title">{{ opt.title }}</div>
                <v-icon
                  v-if="selectedPlanType === opt.key"
                  color="#1bca3f"
                  class="plan-radio-icon"
                >
                  mdi-radiobox-marked
                </v-icon>
                <v-icon v-else color="#B0B0B0" class="plan-radio-icon">
                  mdi-radiobox-blank
                </v-icon>
              </div>
              <div class="plan-subtitle">{{ opt.subtitle }}</div>
              <ul class="plan-features">
                <li v-for="(f, i) in opt.features" :key="i">{{ f }}</li>
              </ul>
            </v-card-text>
          </v-card>
        </div>

        <!-- Choose Renewal -->
        <div class="renewal-section">
          <span
            class="section-label"
            style="margin-right: 20px;padding-top: 20px;"
            >Choose Renewal</span
          >
          <v-radio-group
            v-model="selectedPlanCycle"
            row
            class="renewal-radio-group"
            style="padding-top: 20px!important;"
            @change="setCycle(selectedPlanCycle)"
          >
            <v-radio
              v-for="(cycle, index) in renewalCycles"
              :key="index"
              :label="cycle.name"
              :value="cycle.value"
              color="#1bca3f"
              class="renewal-radio"
            ></v-radio>
          </v-radio-group>
        </div>

        <div class="price-container" style="padding-top: 20px;">
          <div class="price-details">
            <div class="discounted-price" style="padding-left: 6px;">
              {{ planCurrency }} {{ perUserPrice }}
              <span style="font-size: 16px;color:grey;font-weight: 400;"
                >/user</span
              >
            </div>
          </div>
          <div class="final-price-info" style="padding-top: 20px;">
            You will be charged {{ planCurrency }} {{ planPrice }} (+Taxes) per
            {{ selectedPlanCycle.slice(0, -2) }}
          </div>
        </div>

        <v-row class="ma-0 px-0 py-3 pt-8" justify="center" align="center">
          <v-row>
            <v-col
              cols="12"
              sm="5"
              align="right"
              style="padding-top: 24px;"
              class="hidden-xs-only"
            >
              Choose No of Users
            </v-col>
            <v-col cols="3" sm="1" align="right" style="padding-top: 20px;">
              <v-btn
                class="inverted--text"
                color="#37cf37"
                fab
                x-small
                @click="setUserCount('minus')"
              >
                <v-icon>mdi-minus</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="3" sm="2">
              <v-text-field
                v-model="userCount"
                label="User Count"
                solo
                background-color="inverted"
                type="number"
                @keyup="setUserCount"
              ></v-text-field>
            </v-col>
            <v-col cols="3" sm="1" style="padding-top: 20px;">
              <v-btn
                class="inverted--text"
                color="#37cf37"
                fab
                x-small
                @click="setUserCount('plus')"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </v-col>

            <v-col cols="3" sm="1">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="primary"
                    style="opacity: 0.7"
                    dark
                    v-bind="attrs"
                    v-on="on"
                  >
                    info_outline
                  </v-icon>
                </template>
                <span
                  >For example, if you have 3 members and you want to add one
                  more, make Total Member Count 4. <br />
                  For example, if you have 3 members and you want to reduce,
                  delete the 3rd member and make Total Member Count 2.
                </span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-row class="ma-0 pa-0" justify="center">
          <div class="d-flex justify-center flex-wrap" style="gap: 8px;">
            <v-btn
              v-if="isPaid"
              class="primarygrad"
              dark
              :disabled="memberUpdate"
              style="color: white!important;"
              @click.native="pay('update')"
              >Update</v-btn
            >

            <v-btn
              v-if="isPaid"
              color="white"
              style="color: #4f5050"
              :disabled="afterUpdate"
              @click.native="cancelSubscription"
              >Cancel Subscription</v-btn
            >

            <v-btn
              v-else
              class="primarygrad"
              dark
              :disabled="afterUpdate"
              style="color: white!important;"
              @click.native="pay('new')"
              >Pay</v-btn
            >

            <v-btn
              v-if="isPaid && hasUpdateUrl"
              color="primary"
              outlined
              @click.native="openUpdateCardUrl"
            >
              <v-icon left small>mdi-credit-card</v-icon>
              Update Card Details
            </v-btn>
          </div>
        </v-row>
      </v-card-actions>

      <div style="padding-bottom: 30px;"></div>
    </v-card>

    <v-card v-if="billings.length > 0" class="customBorderRadius" elevation="2">
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
          outlined
          dense
          class="customBorderRadius"
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="billings"
        :search="search"
        class="customBorderRadius"
      >
        <template v-slot:item.invoice="{ item }">
          <v-chip v-if="item.paid && !item.deleted" dark color="success">
            Paid
          </v-chip>

          <v-chip
            v-else-if="!item.paid && !item.deleted"
            color="red lighten-3"
            dark
            @click="pay(item.invoice)"
          >
            Pay
          </v-chip>

          <v-chip v-else dark color="error">
            Deleted
          </v-chip>
        </template>

        <template v-slot:item.createdOn="{ item }">
          {{ $moment(item.createdOn).format("lll") }}
        </template>

        <template v-slot:item.amount="{ item }">
          {{ item.amount }} {{ item.currency }}
        </template>

        <template v-slot:item.paid="{ item }">
          <v-chip v-if="!item.deleted" dark @click="pay(item.invoice)">
            Invoice
          </v-chip>
        </template>

        <template v-slot:item.action="{ item }">
          <v-btn
            v-if="!item.paid && !item.deleted"
            icon
            color="error"
            @click="removeInvoice(item.id)"
          >
            <v-icon>mdi-trash-can-outline</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>

    <!-- Loader -->
    <v-dialog v-model="loader" persistent width="300">
      <v-card color="primarygrad white--text" dark>
        <v-card-text style="padding: 18px 25px">
          <h3 style="margin-bottom: 5px; font-weight: 400; font-size: 16px">
            Please Wait...
          </h3>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- FAQ Section -->
    <v-card class="mt-4 pa-4 faq-section">
      <v-card-title>
        <h3 style="color:#30475A; margin:0;">Frequently Asked Questions</h3>
      </v-card-title>
      <v-card-text>
        <v-expansion-panels v-model="faqPanel">
          <v-expansion-panel>
            <v-expansion-panel-header>
              <span class="faq-circle-number">1</span>
              <span style="margin-left: 10px;"
                >My payment failed — what should I do?</span
              >
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div>
                <p>
                  If your payment fails, it’s usually due to one of the
                  following:
                </p>
                <div class="faq-bullet-list">
                  <div class="faq-bullet-item">
                    The card has <strong>expired</strong> or has
                    <strong>insufficient balance</strong>.
                  </div>
                  <div class="faq-bullet-item">
                    Your <strong>PayPal account declined</strong> the charge.
                  </div>
                  <div class="faq-bullet-item">
                    The payment gateway couldn’t verify your card or account.
                  </div>
                </div>
                <p>To resolve this:</p>
                <div class="faq-step-list">
                  <div class="faq-step-item">
                    Go to the Subscribe tab in GoDial.
                  </div>
                  <div class="faq-step-item">
                    Click the <strong>Pay</strong> button again to retry payment
                    — it will charge your saved card or PayPal account
                    automatically.
                  </div>
                  <div class="faq-step-item">
                    If it still doesn’t go through, click
                    <strong>Cancel</strong>, wait a minute, refresh the page,
                    and then click <strong>Pay</strong> again to re-enter your
                    payment details.
                  </div>
                </div>
                <p>
                  If payment continues to fail, email
                  <a href="mailto:support@godial.cc">support@godial.cc</a> or
                  WhatsApp us at
                  <a href="tel:+917044406666">+91 7044406666</a> from your
                  registered email ID. We’ll send you a secure PayPal payment
                  link so you can complete your payment manually and avoid
                  interruption in your subscription.
                </p>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel>
            <v-expansion-panel-header>
              <span class="faq-circle-number">2</span>
              <span style="margin-left: 10px;"
                >How can I update or change my payment method?</span
              >
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div>
                <p>
                  You can update or change your payment method in this manner:
                </p>
                <div class="faq-step-list">
                  <div class="faq-step-item">
                    Go to the Subscribe tab in your GoDial account.
                  </div>
                  <div class="faq-step-item">
                    Click on the <strong>Cancel</strong> button and wait for
                    about a minute.
                  </div>
                  <div class="faq-step-item">
                    Reload the page, then click on the
                    <strong>Pay</strong> button.
                  </div>
                  <div class="faq-step-item">
                    Add your new card or PayPal details, and complete the
                    payment.
                  </div>
                </div>
                <p>
                  If your plan is billed via PayPal, you can also update your
                  linked card or bank directly in your PayPal account.
                </p>
                <p>
                  If you face any issues during this process, email
                  <a href="mailto:support@godial.cc">support@godial.cc</a> or
                  WhatsApp us at
                  <a href="tel:+917044406666">+91 7044406666</a> from your
                  registered email ID. We’ll send you a secure PayPal payment
                  link so you can update or complete your payment manually.
                </p>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel>
            <v-expansion-panel-header>
              <span class="faq-circle-number">3</span>
              <span style="margin-left: 10px;"
                >How do I add more team members or seats?</span
              >
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div>
                <p>
                  To add new users to your GoDial account, follow these steps:
                </p>
                <div class="faq-step-list">
                  <div class="faq-step-item">
                    Go to the Subscribe tab in your GoDial account.
                  </div>
                  <div class="faq-step-item">
                    Increase the Member Limit to the number of users you want to
                    add.
                  </div>
                  <div class="faq-step-item">
                    Click on <strong>Update</strong> — the payment for the
                    additional users will be automatically charged from your
                    saved card or PayPal account.
                  </div>
                </div>
                <p>
                  If the payment doesn’t process automatically: wait for a
                  minute and refresh the page, then try again. Make sure your
                  payment method is active and valid in Paddle. If it still
                  doesn’t work, email
                  <a href="mailto:support@godial.cc">support@godial.cc</a> or
                  WhatsApp us at
                  <a href="tel:+917044406666">+91 7044406666</a> from your
                  registered email ID.
                </p>
                <p>
                  Our team will send you a secure PayPal payment link so you can
                  complete the payment manually, after which we’ll add the extra
                  users to your account.
                </p>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel>
            <v-expansion-panel-header>
              <span class="faq-circle-number">4</span>
              <span style="margin-left: 10px;"
                >How do I view or download past invoices?</span
              >
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div>
                <p>
                  You can view or download all your past invoices in the
                  following ways:
                </p>
                <div class="faq-step-list">
                  <div class="faq-step-item">
                    After every successful payment, an invoice is automatically
                    emailed to your registered email ID in GoDial — usually the
                    manager account email or the billing email ID.
                  </div>
                  <div class="faq-step-item">
                    You can also access your billing history anytime through the
                    Manage Subscription link available in your GoDial billing
                    emails.
                  </div>
                  <div class="faq-step-item">
                    Once inside the Paddle billing portal, go to
                    <strong>Billing History → View / Download Invoice</strong>.
                  </div>
                </div>
                <p>
                  If you can’t find your invoices, search your inbox for emails
                  from <code>@paddle.com</code>. Still can’t locate them? Email
                  <a href="mailto:support@godial.cc">support@godial.cc</a> or
                  WhatsApp us at
                  <a href="tel:+917044406666">+91 7044406666</a> from your
                  registered email ID, and we’ll resend your invoices or share a
                  copy directly.
                </p>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel>
            <v-expansion-panel-header>
              <span class="faq-circle-number">5</span>
              <span style="margin-left: 10px;"
                >Can I switch from PayPal to another card (or vice versa)?</span
              >
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div>
                <p>Yes, you can switch your payment method anytime.</p>
                <div class="faq-step-list">
                  <div class="faq-step-item">
                    Go to the Subscribe tab in your GoDial account.
                  </div>
                  <div class="faq-step-item">
                    Click on the <strong>Cancel</strong> button, then wait a
                    minute and reload the page.
                  </div>
                  <div class="faq-step-item">
                    Click on the <strong>Pay</strong> button again and enter
                    your new payment details — either a card or PayPal account.
                  </div>
                </div>
                <p>
                  Once payment is made, your new payment method will be saved
                  for future renewals.
                </p>
                <p>
                  If you prefer, our team can help you make the switch manually.
                  Just email
                  <a href="mailto:support@godial.cc">support@godial.cc</a> or
                  WhatsApp us at
                  <a href="tel:+917044406666">+91 7044406666</a> from your
                  registered email ID, and we’ll send you a secure PayPal
                  payment link to update your subscription easily.
                </p>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment-timezone";
import fb from "../../js/firebase";
import countries from "../../js/countries";

export default {
  data() {
    return {
      afterUpdate: false,
      planName: "",
      planExpiry: "",
      planUserLimit: "",
      prices: false,
      planModule: [],
      min: 1,
      max: 1000,
      numberOfMembers: 0,
      selectedPlanType: "sim",
      planOptions: [
        {
          key: "sim",
          title: "Sim Based Dialer",
          subtitle: "Affordable, reliable SIM calling",
          features: [
            "Android phone + SIM calling",
            "Works offline over cellular",
            "No cloud recordings",
          ],
        },
        {
          key: "pbx",
          title: "Cloud PBX",
          subtitle: "Browser/softphone calling (team-ready)",
          features: [
            "VoIP-based calling",
            "Team routing and management",
            "Supports recording (plan dependent)",
          ],
        },
      ],
      renewalCycles: [
        { name: "Monthly", value: "monthly" },
        { name: "Yearly", value: "yearly" },
      ],
      godialPlans: [
        {
          name: "Monthly",
          value: "monthly",
          price: 349,
          zohoItemId: "430149000000121038",
        },
        {
          name: "Yearly",
          value: "yearly",
          price: 2799,
          zohoItemId: "430149000000121047",
        },
      ],
      planCurrency: "",
      planPrice: 0,
      planCycleMonth: 1,
      companyData: {},
      selectedPlanCycle: "monthly",
      userCount: 0,
      billings: [],
      loader: false,
      perUserPrice: 0,
      search: "",
      headers: [
        { text: "Invoice Date", value: "createdOn" },
        { text: "Cycle", value: "cycle" },
        { text: "Amount", value: "amount" },
        { text: "Status", value: "invoice" },
        { text: "Download", value: "paid" },
        { text: "Action", value: "action" },
      ],
      faqPanel: 0,
    };
  },
  computed: {
    memberUpdate() {
      return this.userCount < this.numberOfMembers;
    },
    expired() {
      try {
        var self = this;
        var company = this.$store.getters.companyDetails;
        var expiry = moment(company.plan.expiryDate);
        var now = moment().format("DD/MM/YYYY HH:mm:ss");

        var expiryBeforeThreeDays = moment(company.plan.expiryDate)
          .subtract(0, "day")
          .format("DD/MM/YYYY HH:mm:ss");

        var durationofThreeDays = moment(now, "DD/MM/YYYY HH:mm:ss").diff(
          moment(expiryBeforeThreeDays, "DD/MM/YYYY HH:mm:ss"),
          "seconds",
        );

        var duration = moment().diff(moment(expiry), "seconds");
        if (duration > 0) {
          self.expiryOver = true;
        } else {
          self.expiryOver = false;
        }

        if (durationofThreeDays > 0) {
          return true;
        } else {
          return false;
        }
      } catch (e) {
        console.log(e);
        return false;
      }
    },
    ...mapGetters(["ENDPOINT", "user", "companyDetails"]),
    isActive() {
      return this.companyDetails.plan.active;
    },
    isPaid() {
      try {
        if (this.companyDetails.plan.name == "Godial Premium Manual") {
          return false;
        }

        if (this.companyDetails.plan.active == false) {
          return false;
        }

        return (
          this.companyDetails.plan.serverResponse &&
          this.companyDetails.plan.serverResponse.subscription_id
        );
      } catch (e) {
        return false;
      }
    },
    currentPrice() {
      if (this.companyDetails.plan.serverResponse) {
        return (
          this.companyDetails.plan.serverResponse.currency +
          " " +
          this.companyDetails.plan.serverResponse.sale_gross
        );
      } else {
        return "FREE";
      }
    },
    discount() {
      if (!this.prices) return 0;

      if (this.selectedPlanCycle == "monthly") {
        return 0;
      } else {
        var monthly = _.find(this.prices, (p) => {
          return p.subscription.interval == "month";
        });

        var yearly = _.find(this.prices, (p) => {
          return p.subscription.interval == "year";
        });

        var monthlyPrice = Number(monthly.price.net).toFixed(2);
        var yearlyPrice = Number(yearly.price.net).toFixed(2);

        var discount =
          ((monthlyPrice * 12 - yearlyPrice) / (monthlyPrice * 12)) * 100;

        return discount.toFixed(0);
      }
    },
    hasUpdateUrl() {
      try {
        return (
          this.companyDetails.plan.serverResponse &&
          this.companyDetails.plan.serverResponse.update_url
        );
      } catch (e) {
        return false;
      }
    },
  },

  watch: {
    companyDetails() {
      // Update plan type based on plan name
      if (this.companyDetails.plan && this.companyDetails.plan.name) {
        if (this.companyDetails.plan.name === "Godial Cloud PBX") {
          this.selectedPlanType = "pbx";
        } else {
          this.selectedPlanType = "sim";
        }
      }

      // Update currency
      if (this.companyDetails.country.trim().toLowerCase() == "india") {
        this.planCurrency = "INR";
      } else {
        this.planCurrency = "USD";
      }

      // Reload prices for the correct plan type
      this.loadPrices();
    },
  },
  created() {
    this.refresh();
    const self = this;
    this.fetchUserCount();

    this.planName = this.companyDetails.plan.name;

    // Auto-select plan type based on current plan name
    if (
      this.planName === "Godial Cloud PBX" ||
      this.planName.toLowerCase().includes("pbx")
    ) {
      this.selectedPlanType = "pbx";
    } else {
      this.selectedPlanType = "sim";
    }

    // Determine cycle from plan.cycle or from plan name
    let currentCycle = (this.companyDetails.plan.cycle || "").toLowerCase();

    // Extract cycle from plan name if cycle field is empty or not matching
    if (
      !currentCycle ||
      ![
        "yearly",
        "monthly",
        "halfyearly",
        "year",
        "month",
        "halfyear",
      ].includes(currentCycle)
    ) {
      const planNameLower = this.planName.toLowerCase();
      if (
        planNameLower.includes("halfyearly") ||
        planNameLower.includes("half yearly")
      ) {
        currentCycle = "halfyearly";
      } else if (
        planNameLower.includes("yearly") ||
        planNameLower.includes("annual")
      ) {
        currentCycle = "yearly";
      } else if (planNameLower.includes("monthly")) {
        currentCycle = "monthly";
      }
    }

    if (
      currentCycle == "year" ||
      currentCycle == "yearly" ||
      currentCycle == "annual"
    ) {
      this.selectedPlanCycle = "yearly";
    } else if (
      currentCycle == "halfyear" ||
      currentCycle == "halfyearly" ||
      currentCycle == "half yearly"
    ) {
      this.selectedPlanCycle = "halfyearly";
    } else {
      this.selectedPlanCycle = "monthly";
    }

    this.planExpiry = moment(this.companyDetails.plan.expiryDate).format(
      "YYYY-MM-DD",
    );

    this.planUserLimit = this.companyDetails.plan.userLimit;

    this.onSelectSegmentCurrency();

    // Load prices for the selected plan type
    this.loadPrices();

    function loadScript(url, callback) {
      var script = document.createElement("script");
      script.type = "text/javascript";
      if (script.readyState) {
        script.onreadystatechange = function() {
          if (
            script.readyState === "loaded" ||
            script.readyState === "complete"
          ) {
            script.onreadystatechange = null;
            callback();
          }
        };
      } else {
        script.onload = function() {
          callback();
        };
      }

      script.src = url;
      document.getElementsByTagName("head")[0].appendChild(script);
    }

    loadScript("https://cdn.paddle.com/paddle/paddle.js", function() {
      if (self.$store.getters.isPaddleStaging == "true") {
        Paddle.Environment.set("sandbox");
      }

      Paddle.Setup({ vendor: Number(self.$store.getters.paddleKey) });
    });
  },

  methods: {
    openUpdateCardUrl() {
      try {
        const updateUrl = this.companyDetails.plan.serverResponse.update_url;
        if (updateUrl) {
          window.open(updateUrl, "_blank");
        }
      } catch (e) {
        console.error("Error opening update URL:", e);
        this.$swal({
          title: "Error!",
          text: "Unable to open card update page. Please contact support.",
          type: "error",
          confirmButtonColor: "#1bca3f",
        });
      }
    },
    selectPlan(type) {
      this.selectedPlanType = type;
      // Reload prices when plan type changes
      this.loadPrices();
    },
    setUserCount(type) {
      var self = this;
      if (type == "plus" || type == "minus") {
        this.userCount = type == "plus" ? ++this.userCount : --this.userCount;
      }

      if (Number(this.userCount) <= Number(this.numberOfMembers)) {
        this.userCount = this.numberOfMembers;

        return this.$swal({
          title: "Error!",
          text: `You can not decrease member because you already have ${this.numberOfMembers} members.You need to delete member first to decrease.`,
          type: "error",
          showCancelButton: true,
          confirmButtonColor: "#1bca3f",
          cancelButtonColor: "#d33",
          confirmButtonText: "Go to Members",
        })
          .then((willGo) => {
            if (willGo.value) {
              self.$router.push({ path: "/users" });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }

      this.changePrice();
    },
    setCycle(cycle) {
      this.selectedPlanCycle = cycle;
      this.changePrice();
    },
    fetchUserCount() {
      this.userCount = 0;
      this.numberOfMembers = 0;

      var where = {
        companyId: {
          eq: this.$store.getters.user.companyId,
        },
        role: {
          neq: "ApiManager",
        },
        username: {
          neq: "adminhelper",
        },
      };

      this.$http
        .get(
          `${
            this.$store.state.ENDPOINT
          }/accounts/count?where=${encodeURIComponent(JSON.stringify(where))}`,
        )
        .then((response) => {
          response = response.body;
          this.userCount = response.count;

          this.$emit("update-original-user-count", this.userCount);
          this.numberOfMembers = this.userCount;

          // Recalculate price with actual user count
          this.changePrice();
        })
        .catch((err) => {
          this.numberOfMembers = 10;
        });
    },

    onSelectSegmentCurrency() {
      var self = this;

      self.planCurrency = "INR";

      if (this.companyDetails.country.toLowerCase() == "india") {
        self.planCurrency = "INR";
      } else {
        self.planCurrency = "USD";
      }

      self.changePrice();
    },

    changePrice() {
      if (!this.prices) return;
      const self = this;
      const userCount = Number(this.userCount) || 1; // Default to 1 if userCount is 0

      if (this.selectedPlanCycle == "monthly") {
        var monthly = _.find(this.prices, (p) => {
          return p.subscription.interval == "month";
        });

        if (monthly && monthly.price) {
          this.perUserPrice = Number(monthly.price.net);
          this.planPrice = Number(monthly.price.net * userCount).toFixed(2);
          this.planCurrency = monthly.currency;
        }
      } else {
        var yearly = _.find(this.prices, (p) => {
          return p.subscription.interval == "year";
        });

        if (yearly && yearly.price) {
          this.perUserPrice = Number(yearly.price.net);
          this.planPrice = Number(yearly.price.net * userCount).toFixed(2);
          this.planCurrency = yearly.currency;
        }
      }
    },

    pay(mode) {
      const self = this;

      if (self.userCount < self.numberOfMembers) {
        self.$swal({
          type: "warning",
          text:
            "Your account has " +
            self.numberOfMembers +
            " members, you cannot select less than " +
            self.numberOfMembers +
            " users",
        });
        return;
      }
      self
        .$swal({
          text:
            mode == "update"
              ? "Updating your account. Your new subscription charge will be auto prorated and charged from your current payment method. Click Ok to proceed"
              : "Your subscription will start after payment is made, Click Ok to proceed.",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "info",
          cancelButtonColor: "#d33",
          confirmButtonText: "Ok",
        })
        .then(async (result) => {
          if (result.value) {
            self.afterUpdate = true;

            var country = _.find(countries, (c) => {
              return (
                c.name.toLowerCase().trim() ==
                self.companyDetails.country.toLowerCase().trim()
              );
            });

            if (!country) country = "US";
            else country = country.code;

            // Get product ID based on selected plan type and cycle
            var productId;
            if (self.selectedPlanType === "sim") {
              productId =
                self.selectedPlanCycle.toLowerCase() === "monthly"
                  ? self.$store.getters.monthlyProd
                  : self.$store.getters.yearlyProd;
            } else if (self.selectedPlanType === "pbx") {
              productId =
                self.selectedPlanCycle.toLowerCase() === "monthly"
                  ? self.$store.getters.cloudPbxMonthly
                  : self.$store.getters.cloudPbxYearly;
            }

            if (!productId) {
              self.$swal({
                type: "error",
                text: "Product configuration error. Please contact support.",
              });
              self.afterUpdate = false;
              return;
            }

            if (mode == "update") {
              await self.$http.post(`${self.ENDPOINT}/plans/changepaddle`, {
                opts: {
                  userCount: Number(self.userCount),
                  plan_id: productId,
                },
              });

              self.$swal({
                type: "success",
                text:
                  "Update request has been sent. Your account will updated shortly, Kindly refresh after 1 minute.",
              });
              self.afterUpdate = false;
              self.refresh();
            } else {
              // Log for debugging
              console.log("Opening Paddle Checkout with:", {
                product: productId,
                quantity: Number(self.userCount),
                country: country,
              });

              Paddle.Checkout.open({
                product: productId,
                email: self.user.email,
                country: country,
                quantity: Number(self.userCount),
                passthrough: self.user.companyId,
                successCallback: function(data) {
                  var checkoutId = data.checkout.id;

                  Paddle.Order.details(checkoutId, function(data2) {
                    try {
                      fb.log("purchase", {
                        item: data2.checkout.title,
                        price: {
                          amount: data2.order.total,
                          currency: data2.order.currency,
                        },
                        currency: data2.order.currency,
                        value: data2.order.total,
                        order_number: data2.order.order_id,
                        subscription_id: data2.order.subscription_id,
                        catalog_img: data2.checkout.image_url,
                      });

                      self.$swal({
                        type: "success",
                        text:
                          "Thank you for subscribing to GoDial. Your account will updated shortly, Kindly refresh after 1 minute.",
                      });

                      self.afterUpdate = false;

                      self.refresh();
                    } catch (e) {
                      console.log(e);
                    }
                  });
                },
                closeCallback: function(data) {
                  self.afterUpdate = false;

                  self.refresh();

                  fb.log("purchase_cancel");
                },
              });
            }
          }
        });
    },

    autoDetectTimeZone() {
      this.companyDetails.tz.name = moment.tz.guess();
    },

    cancelSubscription() {
      const self = this;

      self
        .$swal({
          title: "Are you sure?",
          text: "Do you want to cancel your subscription?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#1bca3f",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes",
          cancelButtonText: "No",
        })
        .then((result) => {
          if (result.value) {
            self.afterUpdate = true;
            self.$http
              .post(`${self.ENDPOINT}/plans/cancelpaddle`)
              .then((response) => {
                self.afterUpdate = false;
                self.refresh();
              })
              .catch((e) => {
                self.afterUpdate = false;
                self.$swal({
                  type: "Error",
                  text:
                    "Something went wrong while cancelling your subscription",
                });
              });
          }
        });
    },
    refresh() {
      this.$store.dispatch("getCompanyDetails", {
        companyId: this.user.companyId,
      });
      this.loadPrices();
    },

    loadPrices() {
      const self = this;
      var country = _.find(countries, (c) => {
        return (
          c.name.toLowerCase().trim() ==
          self.companyDetails.country.toLowerCase().trim()
        );
      });

      if (!country) country = "US";
      else country = country.code;

      var product_ids = [];

      // Load prices based on selected plan type
      if (self.selectedPlanType === "sim") {
        product_ids.push(
          self.$store.getters.monthlyProd,
          self.$store.getters.yearlyProd,
        );
      } else if (self.selectedPlanType === "pbx") {
        product_ids.push(
          self.$store.getters.cloudPbxMonthly,
          self.$store.getters.cloudPbxYearly,
        );
      }

      this.$http
        .post(`${process.env.VUE_APP_ENDPOINT}/billings/get-paddle-product`, {
          customer_country: country,
          productIds: product_ids,
        })
        .then((response) => {
          if (
            response.body &&
            response.body.response &&
            response.body.response.products
          ) {
            self.prices = response.body.response.products;
            self.changePrice();
          }
        })
        .catch((err) => {
          console.error("Error loading prices:", err);
        });
    },

    add() {
      this.$http
        .post(`${this.$store.state.ENDPOINT}/coupons/redeem`, {
          code: this.appSumoCode,
        })
        .then((response) => {
          this.refresh();
        })
        .catch((err) => {
          if (err.body.error && err.body.error.message) {
            this.$swal({ type: "error", text: err.body.error.message });
            return;
          }

          this.$swal({
            type: "error",
            text: "error while redeeming this code ",
          });
        });
    },

    removeInvoice(billingId) {
      const self = this;
      self
        .$swal({
          title: "Are you sure?",
          text: "Do you want to delete this invoice?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#1bca3f",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes",
        })
        .then((result) => {
          if (result.value) {
            self.$http
              .delete(`${self.$store.state.ENDPOINT}/billings/${billingId}`)
              .then((response) => {
                self.refresh();
                self.$swal({
                  type: "success",
                  text: "Invoice deleted successfully",
                });
              })
              .catch((e) => {
                self.$swal({
                  type: "error",
                  text: "Error deleting invoice",
                });
              });
          }
        });
    },
  },
};
</script>

<style scoped>
.faq-bullet-list {
  margin-left: 1.25rem;
  padding-left: 0.5rem;
}
.faq-bullet-item {
  position: relative;
  padding-left: 1.5em;
  margin-bottom: 0.5em;
}
.faq-bullet-item::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0.7em;
  width: 0.5em;
  height: 0.5em;
  background: #30475a;
  border-radius: 50%;
  display: inline-block;
}
.faq-step-list {
  counter-reset: stepnum;
  margin-left: 1.25rem;
  padding-left: 0.5rem;
}
.faq-step-item {
  position: relative;
  padding-left: 2.5em;
  margin-bottom: 0.5em;
}
.faq-step-item::before {
  counter-increment: stepnum;
  content: counter(stepnum);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #37cf37;
  color: #fff;
  font-weight: bold;
  font-size: 16px;
  position: absolute;
  left: 0;
  top: 0;
}
.faq-circle-number {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  max-width: 32px;
  border-radius: 50%;
  background: #37cf37;
  color: #fff;
  font-weight: bold;
  font-size: 18px;
  box-shadow: 0 2px 6px rgba(55, 207, 55, 0.15);
}

h1,
h2 {
  font-weight: normal;
}

.section-label {
  font-size: 16px;
  font-weight: 500;
  color: #30475a;
  margin-bottom: 12px;
}

.plan-card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 24px;
  margin-bottom: 32px;
}

.plan-card {
  border: 2px solid #e0e0e0;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
}

.plan-card:hover {
  border-color: #1bca3f;
  box-shadow: 0 4px 12px rgba(27, 202, 63, 0.15);
}

.plan-card.selected {
  border-color: #1bca3f;
  background-color: #f0f9f3;
  box-shadow: 0 4px 12px rgba(27, 202, 63, 0.2);
}

.plan-card-content {
  padding: 20px;
}

.plan-card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
}

.plan-title {
  font-size: 18px;
  font-weight: 600;
  color: #30475a;
}

.plan-radio-icon {
  font-size: 24px;
}

.plan-subtitle {
  font-size: 14px;
  color: #757575;
  margin-bottom: 16px;
}

.plan-features {
  list-style: none;
  padding: 0;
  margin: 0;
}

.plan-features li {
  font-size: 13px;
  color: #616161;
  padding: 8px 0;
  padding-left: 20px;
  position: relative;
}

.plan-features li::before {
  content: "•";
  position: absolute;
  left: 0;
  color: #1bca3f;
  font-weight: bold;
}

.renewal-section {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  flex-wrap: wrap;
}

.renewal-radio-group {
  display: flex;
  gap: 16px;
}

.renewal-radio {
  margin-right: 0;
}

.price-container {
  text-align: center;
  margin: 20px 0;
  padding: 16px;
  background-color: #f5f5f5;
  border-radius: 8px;
}

.price-details {
  display: flex;
  justify-content: center;
  align-items: baseline;
  gap: 12px;
}

.original-price {
  font-size: 16px;
  color: grey;
  text-decoration: line-through;
}

.discounted-price {
  font-size: 36px;
  color: #1d2d50;
  font-weight: bold;
}

.discount-percentage {
  font-size: 14px;
  color: #1bca3f;
  font-weight: 500;
}

.final-price-info {
  font-size: 16px;
  color: #30475a;
  margin-top: 12px;
}

/* Ribbon styles */
.ribbon {
  width: 150px;
  height: 150px;
  overflow: hidden;
  position: absolute;
}

.ribbon::before,
.ribbon::after {
  position: absolute;
  z-index: -1;
  content: "";
  display: block;
  border: 5px solid #2980b9;
}

.ribbon span {
  position: absolute;
  display: block;
  width: 225px;
  padding: 15px 0;
  background-color: #3498db;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
  color: #fff;
  font: 700 18px/1 "Lato", sans-serif;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  text-transform: uppercase;
  text-align: center;
}

.ribbon-top-right {
  top: 69px;
  right: 0px;
}

.ribbon-top-right::before,
.ribbon-top-right::after {
  border-top-color: transparent;
  border-right-color: transparent;
}

.ribbon-top-right::before {
  top: 0;
  left: 0;
}

.ribbon-top-right::after {
  bottom: 0;
  right: 0;
}

.ribbon-top-right span {
  left: 1px;
  top: 22px;
  transform: rotate(45deg);
}

@media (max-width: 767px) {
  .plan-card-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .renewal-section {
    flex-direction: column;
    align-items: flex-start;
  }

  .renewal-radio-group {
    flex-direction: column;
    gap: 12px;
    width: 100%;
  }

  .price-container {
    font-size: 14px;
  }

  .discounted-price {
    font-size: 28px;
  }
}
</style>
